<script>
export default {}
</script>

<template>
  <div class="card shadow">
    <div class="card-body">
      <slot></slot>
    </div>
  </div>
</template>